import { CompanySingleAggregateViewModelInterface } from '@nts/std/interfaces';
import { OCCRootViewModel } from '../occ-root-view-model';
import { CompanySingleAggregateIdentityInterface, CompanySingleAggregateModelInterface, NumericPropertyViewModelInterface } from '@nts/std/interfaces';

export class CompanySingleAggregateViewModel<
  TModel extends CompanySingleAggregateModelInterface<TIdentity>,
  TIdentity extends CompanySingleAggregateIdentityInterface
> extends OCCRootViewModel<TModel, TIdentity> implements CompanySingleAggregateViewModelInterface<TIdentity, TModel> {

  private _companyId: NumericPropertyViewModelInterface;

  get companyId(): NumericPropertyViewModelInterface {
    return this.getNumericPropertyViewModel(
      {
        action: (value) => { this._companyId = value; },
        propertyName: 'companyId',
        value: this._companyId
      }
    );
  }
}
